import { getDecryptedItem } from './methods';

// Item variant mapping for transaction types
const normalizeItemVariant = (itemVariant) => {
  if (!itemVariant) return itemVariant;
  const variant = String(itemVariant).toUpperCase();
  if (variant === 'INSTANT SIP' || variant === 'SIN') return 'ISIP';
  return itemVariant;
};

export async function createLog(eventName, params = {}, isCharged = false, source = "") {
  try {
    const dataLayer = window.dataLayer;
    const notifyVisitor = window.nv;
    const decryptedData = getDecryptedItem("uniqueKey");
    
    // Normalize item_variant for items array
    if (eventName === "Payment_Acknowledged" && params?.items && Array.isArray(params?.items)) {
      params.items = params.items?.map(item => ({
        ...item,
        item_variant: normalizeItemVariant(item?.item_variant)
      }));
    }

    // Remove '+' from mobile if present
    if (params.hasOwnProperty('mobile')) {
      params.mobile = String(params.mobile || "")?.replace("+", "");
    }
    console.log("EventName:", eventName, "\nParams:", params);

    notifyVisitor("event", eventName, params, 1, 1);
    if (eventName === "Payment_Acknowledged") {
      // Push event anyway
      dataLayer?.push({
        event: eventName,
        ecommerce: params,
      });

      const REQUIRED_FIELDS = [
        "price",
        "payment_mode",
        "ucid",
        "payment_state",
        "investor_type",
        "transaction_id",
        "items",
      ];

      // Check if any required field is missing or invalid
      const missingFields = REQUIRED_FIELDS.filter((key) => {
        const val = params[key];
        return (
          val === undefined ||
          val === null ||
          val === "" ||
          (Array.isArray(val) && val.length === 0)
        );
      });
      
      const isInvalid = missingFields.length > 0;

      // Push invalid event if any required field is missing/invalid
      if (isInvalid) {
        notifyVisitor("event",
          "Payment_Acknowledged_Invalid",
          {
            panNo: decryptedData?.panNo,
            source,
            missing: missingFields,
            ...params,
          }, 1, 1);
      }
    }
    else {
      dataLayer?.push({
        event: eventName,
        value: params,
      });
    }
  } catch (e) {
    console.log("error createLog", e);
  }
}

export async function createRouteLog(previousRouteName, currentRouteName) {
  try {
    // const cleverTap = window.clevertap;
    const notifyVisitor = window.nv;

    // cleverTap.event.push(`navigated_to: ${currentRouteName}`);
    notifyVisitor("event", `navigated_to: ${currentRouteName}`);
  } catch (e) {
    console.log("error createRouteLog", e);
  }
}

// To set user by userId or client_UCID
export async function setUserObj(user) {
  try {
    const userObj = {
      Site: user,
    };
    // const cleverTap = window.clevertap;
    const dataLayer = window.dataLayer;
    const notifyVisitor = window.nv;

    // cleverTap.onUserLogin.push(userObj);
    console.log("the user>", userObj, "user", user);
    dataLayer?.push({
      userId: user?.panNo,
      event: "setUserId",
    });
    const notifyUserObject = {
      name: user?.Name || null,
      email: user?.Email || null,
      mobile: String(user?.Phone || "")?.replace("+", ""),
      clientType: user?.clientType || null,
      client_code: user?.Identity || null,
      clientProduct: ["MF"],
    };

    const eventAttribute = {
      clientProduct: ["MF"],
    };

    notifyVisitor("userevent", [
      user?.panNo,
      notifyUserObject,
      "User Logged In",
      eventAttribute,
      10,
      1,
    ]);
  } catch (e) {
    console.log("error setUserObj ", e);
  }
}

// To set new user Details
export async function setNewUserObj(user) {
  try {
    const userObj = {
      Site: user,
    };
    // const cleverTap = window.clevertap;
    const dataLayer = window.dataLayer;
    const notifyVisitor = window.nv;

    // cleverTap.onUserLogin.push(userObj);
    console.log("userObj", userObj, "user", user);
    dataLayer?.push({
      userId: user?.panNo,
      event: "setUserId",
    });
    const notifyUserObject = {
      name: user?.Name || null,
      email: user?.Email || null,
      mobile: String(user?.Phone || "")?.replace("+", ""),
      clientType: user?.clientType || null,
      client_code: user?.Identity || null,
      clientProduct: ["MF"],
    };

    const eventAttribute = {
      clientProduct: ["MF"],
    };

    notifyVisitor("userevent", [
      user?.panNo,
      notifyUserObject,
      "New User Sign-Up",
      eventAttribute,
      10,
      1,
    ]);

    console.log(notifyUserObject, "notifyUserObject");
  } catch (e) {
    console.log("error setUserObj ", e);
  }
}